import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// Styles Import
import styles from "./index.module.css";
import Navbar from "../../components/Navbar/Navbar";

const Layout = ({ children }) => {
  const { fullPageLoading } = useSelector((state) => state.fullPageLoaderSlice);
  return (
    <>
      <Navbar />
      <main className={styles.main}>
        <div className={styles.contentPositionMargin}>{children}</div>
      </main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.object.isRequired,
};

export default Layout;
